export default __webpack_public_path__ + "static/media/pdf.141bbd61.svg";